import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'null';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'null';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true,
        storageKey: 'covenant-tracker-auth',
        storage: window.localStorage,
        autoRefreshToken: true,
        detectSessionInUrl: true,
    },
});

export const isElectron = () => {
    return window && window.process && window.process.type;
};

export const useSupabase = () => {
    return !isElectron();
};